import React from 'react';
import { FreeBusyBarProps } from '../schema/FreeBusyBar.types';
import { getFreeBusyItemBarClass, getFreeBusyItemBarStyling } from './convertFreeBusyStatusToStyle';

/**
 * Renders the free busy bar for the given item, using duration and free busy type
 * @param item The item to render the free busy bar for
 */
export const FreeBusyBar = (props: FreeBusyBarProps) => {
    const { freeBusyType, colorScheme, iconStyles } = props;

    if (freeBusyType == null) {
        // don't render if there's no free busy type
        return null;
    }
    const freeBusySpecificClass = getFreeBusyItemBarClass(
        freeBusyType,
        iconStyles ? iconStyles : null
    );
    const freeBusyStyling = getFreeBusyItemBarStyling(freeBusyType, colorScheme);

    return <div className={freeBusySpecificClass} style={freeBusyStyling} />;
};
